export class StructuredContentService {
    generate(items, lang) {
        return {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": Object.keys(items).map(( key) => ({
                "@type": "Question",
                "name": items[key].question,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": items[key].answer
                }
            })),
            "inLanguage": lang
        };
    }
}